import { createSelector } from 'reselect';

const selectPages = (state: any) => state.pages;


export const selectCurrentItem = createSelector([selectPages], (pages) => pages.current);

export const selectPageListItems = createSelector([selectPages], (pages) => pages.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPageListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPageQueryItems = createSelector([selectPages], (pages) => pages.query);

export const selectCreatedItem = createSelector([selectPages], (pages) => pages.create);

export const selectUpdatedItem = createSelector([selectPages], (pages) => pages.update);

export const selectReadItem = createSelector([selectPages], (pages) => pages.read);

export const selectDeletedItem = createSelector([selectPages], (pages) => pages.delete);

export const selectSearchedItems = createSelector([selectPages], (pages) => pages.search);

export const selectItemsCount = createSelector([selectPages], (pages) => pages.count);

export const selectItemsFilter = createSelector([selectPages], (pages) => pages.filter);